import { connect } from "react-redux";
import SimMenu from "../components/SimMenu";
import { sceneSlice } from "../../store/sceneSlice";
import { sessionSlice } from "../../store/sessionSlice";

const mapStateToProps = (state) => {
  return {
    pdb: state.scene.pdb,
    temperature: state.scene.temperature,
    maxTemperature: state.scene.maxTemperature,
    rate: state.scene.updateRate,
    isSimOn: state.session.isSimOn,
    engine: state.session.engine,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateRates: (type) => {
      dispatch(sceneSlice.actions.emitUpdateRatesChange({ type }));
    },
    onTemperatureSet: (newT) => {
      dispatch(sceneSlice.actions.emitTemperatureSet({ newT }));
    },
    onWritePDB: () => {
      dispatch(sessionSlice.actions.emitWritePDB());
    },
    onStartSim: () => {
      dispatch(sessionSlice.actions.emitStartSim());
    },
    onStopSim: () => {
      dispatch(sessionSlice.actions.emitStopSim());
    },
    onMolRotationSetByValue: (newMolRotations) => {
      console.log("origin 3 (good one for test button)")
      console.log(newMolRotations)
      dispatch(sessionSlice.actions.emitSetMolRotationByValue({ newMolRotations }));
    },
    onMolRotationChange: (newMolRotations) => {
      console.log("origin 3 (good one for test button rot change)")
      console.log(newMolRotations)
      dispatch(sessionSlice.actions.emitSetMolRotationChange({ newMolRotations }));
    },
  };
};

export const SimMenuContainer = connect(mapStateToProps, mapDispatchToProps)(SimMenu);
